import script from "./fenxi.vue?vue&type=script&setup=true&lang=js"
export * from "./fenxi.vue?vue&type=script&setup=true&lang=js"

import "./fenxi.vue?vue&type=style&index=0&id=1655b41c&lang=scss&scoped=true"

import exportComponent from "D:\\liu\\jmzc\\jimuERPVUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1655b41c"]])

export default __exports__